<template>
  <main role="main" class="py-4">
    <b-container class="mb-3">
      <div v-if="isLoading" class="text-center py-5"><b-spinner /></div>

      <template v-if="customer">
        <div class="d-flex flex-row justify-content-between mb-4">
          <h4 class="m-0">{{ customer.name }}</h4>
        </div>

        <div class="d-flex flex-row">
          <div class="left-panel mr-4">
            <b-list-group>
              <b-list-group-item :to="'/customers/details/' + id" active-class="" exact-active-class="active">{{
                $t("overview") }}</b-list-group-item>
              <b-list-group-item :to="`/customers/details/${id}/subscription`" active-class=""
                exact-active-class="active">{{ $t("subscriptionPlan") }}</b-list-group-item>
              <b-list-group-item :to="`/customers/details/${id}/meetings`" active-class=""
                exact-active-class="active">{{ $t("meeting") }}</b-list-group-item> <b-list-group-item
                v-if="isActiveGMToken" :to="`/customers/details/${id}/tokens`" active-class=""
                exact-active-class="active">{{ $t("manageGMToken") }}</b-list-group-item>
              <b-list-group-item v-if="isActiveVoiceText" :to="`/customers/details/${id}/smartvoicetokens`"
                active-class="" exact-active-class="active">{{ $t("smartVoiceToken") }}</b-list-group-item>
            </b-list-group>
          </div>
          <div class="flex-grow-1">
            <router-view @refresh="fetchCustomer"></router-view>
          </div>
        </div>
      </template>

    </b-container>
  </main>
</template>

<style lang="scss" scoped>
.left-panel {
  width: 150px;
  flex-shrink: 0;
}
</style>

<script lang="ts">
import { Component } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import * as customerService from "@/service/customerService";
import { featureCode } from '@/views/enums/featureCode';
import {Status} from "@/views/enums/EnableStatus";
@Component
export default class CustomerDetails extends BaseComponent {

  id: number = null;

  isLoading = false;
  customer = null;
  isActiveGMToken = false;
  isActiveVoiceText = false;
  isActiveFaceId = false;


  mounted() {
    this.id = +this.$route.params.id || null;
    this.fetchCustomer();
  }


  async fetchCustomer() {
    try {
      this.isLoading = true;
      this.customer = await customerService.getDetails(this.id);
      this.isActiveGMToken = this.customer.activeGMToken === Status.ENABLE;
      // this.isActiveVoiceText = this.customer.activeVoiceText === 1;
      this.isActiveFaceId = this.customer.activeFaceId === Status.ENABLE;
      const customerFeature = await customerService.getCustomerFeature(this.id);
      this.isActiveVoiceText = customerFeature?.features?.some(f => (f.featureCode === featureCode.ALLOW_SUMMARY || f.featureCode === featureCode.ALLOW_LIVECAPTION) && f.isActive === Status.ENABLE)?? false;
    } catch (e) {
      this.toastError(e);
    } finally {
      this.isLoading = false;
    }
  }
}
</script>
